import {
  GenrePayload,
  ReleaseType,
  ReleaseVersion,
  UpdateReleaseVersionSongPatchData,
  ValidationError,
} from 'types/releases';
import get from 'lodash/get';
import { DDL, Option } from 'types/general.types';
import { SoundCloudVersionDetailsFormData } from 'app/components/Releases/SoundCloudVersionDetailsForm/types';

export const getReleaseSongVersionProperty = (
  song: ReleaseVersion['song'],
  path: string
) => get(song.overrides, path) || get(song.snapshot, path) || '';

export const getLanguage = (languageCodes: DDL, language?: string) =>
  language
    ? {
        title: languageCodes[language].name,
        value: languageCodes[language].key,
      }
    : null;

export const convertFormDataToGenreOperationsData: (
  data: Partial<SoundCloudVersionDetailsFormData>,
  currentGenre: Option | null | undefined,
  releaseVersion: ReleaseVersion
) => UpdateReleaseVersionSongPatchData = (
  data,
  currentGenreProp,
  releaseVersion
) => {
  const overrides = releaseVersion.song.overrides.genres || [];
  const currentGenre = currentGenreProp?.value.toString();
  const canRemoveGenre =
    (data.genre || data.genre === null) &&
    currentGenre &&
    overrides.includes(currentGenre);

  const addOperation: GenrePayload[] =
    data.genre && releaseVersion.song.snapshot.genres?.[0] !== data.genre.value
      ? [{ genre: data.genre.value.toString(), op: 'ADD' }]
      : [];

  const removeOperation: GenrePayload[] = canRemoveGenre
    ? [{ genre: currentGenre, op: 'REMOVE' }]
    : [];

  const genresData = [...addOperation, ...removeOperation];

  return {
    ...(genresData.length > 0 ? { genres: genresData } : {}),
  };
};

export const getConnexValidationMessage = (
  errorCode?: ValidationError['errorCode']
) => {
  switch (errorCode) {
    case 'MISSING_SONG_DISPLAY_ARTIST_NAME':
      return 'Artist missing';
    case 'MISSING_CONTRIBUTION_ROLE':
      return 'Role missing';
    case 'INVALID_CONTRIBUTION_ROLE':
      return 'Invalid role';
    case 'MISSING_SONG_GENRE':
      return 'Genre missing';
    case 'INVALID_SONG_GENRE':
      return 'Invalid genre';
    case 'MISSING_NON_SONGWRITER_CONTRIBUTION':
      return 'Non-songwriter credit missing';
    case 'INVALID_SPLIT':
      return 'Invalid split';
    default:
      return '';
  }
};

export const getReleaseTypeName = (type?: ReleaseType) => {
  if (type === ReleaseType.LABEL_V2) {
    return 'Connex';
  }
  return type;
};
